import { defaultTo } from "lodash";

export interface IVisitSalesItemAttributeListValueModel {
    visitSalesItemAttributeListValueId: number,
    visitSalesItemAttributeId: number,
    name: string,
    storage: string,
    sortOrder: number,
    isSelected: boolean,
}

export class VisitSalesItemAttributeListValueModel implements Record<keyof IVisitSalesItemAttributeListValueModel, any> {
    visitSalesItemAttributeListValueId: number;
    visitSalesItemAttributeId: number;
    name: string;
    storage: any;
    storageParsed: any;
    sortOrder: number;
    isSelected: boolean;

    constructor(params: Partial<IVisitSalesItemAttributeListValueModel>) {
        this.visitSalesItemAttributeListValueId = defaultTo(params.visitSalesItemAttributeListValueId, 0)
        this.visitSalesItemAttributeId = defaultTo(params.visitSalesItemAttributeId, 0)
        this.name = defaultTo(params.name, "")
        this.storage = params.storage;
        this.storageParsed = params.storage == "undefined" ? undefined : JSON.parse(defaultTo(params.storage, "{}"))
        this.sortOrder = defaultTo(params.sortOrder, 0)
        this.isSelected = defaultTo(params.isSelected, false)
    }
}
